module.exports = __webpack_public_path__ + "assets/havoc.png?49750e396fb49a221fdf3b541ca7e3b9";